// This are multi-window events passes in-b/w
export enum EventTypeEnum {
  ToggleHeader = 'ToggleHeader',
  UpdateURL = 'UpdateURL',
  PasteInVM = 'PasteInVM',
  ReloadSteps = 'ReloadSteps',
  PageLock = 'PageLock'
}
